import {FALSE} from 'sass';

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
    {
        path: '/',
        component: () => import('@/views/layouts/index'),
        redirect: '/home',
        // redirect: '/industryIntegration',
        meta: {
            title: '首页',
            keepAlive: false
        },
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('@/views/home/index'),
                meta: {title: '首页', keepAlive: false, requireAuth: false}
            },
            {
                path: '/myindustrychain',
                name: 'MyIndustryChain',
                component: () => import('@/views/myindustrychain/index'),
                meta: {title: '我的产业链', keepAlive: false, requireAuth: true}
            },
            {
                path: '/industryIntegration',
                name: 'IndustryIntegration',
                component: () => import('@/views/industryIntegration/index'),
                meta: {title: '产业通', keepAlive: false, requireAuth: false}
            },
            {
                path: '/industryIntegration/report',
                name: 'IndustryIntegrationReport',
                component: () => import('@/views/industryIntegration/report'),
                meta: {title: '产业通上报', keepAlive: false, requireAuth: false}
            },
            {
                path: '/pubHome',
                name: 'PubHome',
                component: () => import('@/views/home/index'),
                meta: {title: '产业通', keepAlive: false, requireAuth: false}
            },
            {
                path: '/login',
                name: 'Login',
                component: () => import('@/views/login/index'),
                meta: {title: '登录', keepAlive: false, requireAuth: false}
            },
            {
                path: '/membership',
                name: 'MembershipIndex',
                component: () => import('@/views/membership/index'),
                meta: {keepAlive: false, requireAuth: false}
            },
            {
                path: '/detail',
                name: 'Detail',
                component: () => import('@/views/home/detail'),
                meta: {title: '详情', keepAlive: false, requireAuth: true}
            },
            {
                path: '/follow',
                name: 'Follow',
                component: () => import('@/views/follow/index'),
                meta: {title: '关注列表', keepAlive: false, requireAuth: true}
            },
            {
                path: '/follow/edit',
                name: 'FollowEdit',
                component: () => import('@/views/follow/edit'),
                meta: {title: '编辑', keepAlive: false, requireAuth: true}
            },
            {
                path: '/notice',
                name: 'FollowNotice',
                component: () => import('@/views/follow/notice'),
                meta: {keepAlive: false, requireAuth: true}
            },
            {
                path: '/membership/edit',
                name: 'MembershipEdit',
                component: () => import('@/views/membership/edit'),
                meta: {keepAlive: false, requireAuth: false}
            },
            {
                path: '/membership/result',
                name: 'MembershipResult',
                component: () => import('@/views/membership/result'),
                meta: {keepAlive: false, requireAuth: false}
            },

            {
                path: '/consult',
                name: 'ConsultIndex',
                component: () => import('@/views/consult/index'),
                meta: {keepAlive: true, requireAuth: false}
            },
            {
                path: '/consult/detail',
                name: 'ConsultDetail',
                component: () => import('@/views/consult/detail'),
                meta: {keepAlive: false, requireAuth: false}
            },
            {
                path: '/activity',
                name: 'Activity',
                component: () => import('@/views/activity/index'),
                meta: {keepAlive: true, requireAuth: false}
            },
            {
                path: '/error/expired',
                name: 'Error',
                component: () => import('@/views/error/expired'),
                meta: {keepAlive: false, requireAuth: true}
            },
            {
                path: '/h5/finance',
                name: 'H5Finance',
                component: () => import('@/views/h5/finance'),
                meta: {title: '融资通', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/financeRegistered',
                name: 'H5FinanceRegistered',
                component: () => import('@/views/h5/financeRegistered'),
                meta: {title: '融资通完成注册', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/introduce',
                name: 'H5Introduce',
                component: () => import('@/views/h5/introduce'),
                meta: {title: '企业简介', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/cultivationSurveyForm',
                name: 'H5CultivationSurveyForm',
                component: () => import('@/views/h5/cultivationSurveyForm'),
                meta: {title: '企业梯度培育调研表', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/cultivationSurveyFormSubmitted',
                name: 'H5CultivationSurveyFormSubmitted',
                component: () => import('@/views/h5/cultivationSurveyFormSubmitted'),
                meta: {title: '企业梯度培育调研表完成提交', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5registration/login',
                name: 'H5RegistrationLogin',
                component: () => import('@/views/h5registration/login'),
                meta: {title: '对接报名平台登录', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5registration/information',
                name: 'RegistrationInformation',
                component: () => import('@/views/h5registration/information'),
                meta: {title: '对接报名平台企业信息', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5registration/home',
                name: 'RegistrationHome',
                component: () => import('@/views/h5registration/home'),
                meta: {title: '对接报名平台企业主页', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/capitalBusinessForm',
                name: 'H5CapitalBusinessForm',
                component: () => import('@/views/h5/capitalBusinessForm'),
                meta: {title: '资本新商学调研表', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/capitalBusinessFormSubmitted',
                name: 'H5CapitalBusinessFormSubmitted',
                component: () => import('@/views/h5/capitalBusinessFormSubmitted'),
                meta: {title: '企业梯度培育调研表完成提交', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/trisomeBatch1',
                name: 'H5TrisomeBatch1',
                component: () => import('@/views/h5/trisomeBatch1'),
                meta: {title: '面壁者计划', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/trisomeSubmitted',
                name: 'H5TrisomeSubmitted',
                component: () => import('@/views/h5/trisomeSubmitted'),
                meta: {title: '面壁者计划', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/guestbook',
                name: 'H5Guestbook',
                component: () => import('@/views/h5/guestbook'),
                meta: {title: '留言板', keepAlive: false, requireAuth: false}
            },
            {
                path: '/h5/guestbookSubmitted',
                name: 'H5GuestbookSubmitted',
                component: () => import('@/views/h5/guestbookSubmitted'),
                meta: {title: '留言板已提交', keepAlive: false, requireAuth: false}
            },
        ]
    }
]
